export type IconTheme =
  | "black"
  | "white"
  | "purple"
  | "darkPurple"
  | "green"
  | "gray";

/**
 * Single source of truth for icon color themes. Every icon exposes
 * these so a token change lives in one place instead of being copy-pasted per icon. 
 */
export const ICON_THEME_COLOR: Record<IconTheme, string> = {
  black: "elem-neutral",
  white: "elem-neutral-inverse",
  purple: "elem-brand",
  darkPurple: "elem-brand-strong",
  green: "success",
  gray: "text-neutral-accent",
};
